import styled from 'styled-components';

export const PricingAlertContainer = styled.div`
  &.bd-callout {
    margin-bottom: 0;
  }

  h4 {
    margin-top: 0;
    font-weight: bold;
    font-size: 18px;
  }

  p {
    font-size: 16px;
  }

  a {
    font-weight: bold;
  }
`;
